// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function prettifyValue(value: any, type: string, showZeroCounts = false): any {
  if (!value) {
    if (value === 0 && showZeroCounts) {
      return value;
    }
    return 'N/A';
  }

  switch (type) {
    case 'CURRENCY':
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(Number(value));
    case 'ROUNDED_CURRENCY':
      return (
        '$' +
        new Intl.NumberFormat('en-US', {
          compactDisplay: 'long',
          maximumFractionDigits: 1,
          minimumFractionDigits: 0,
          notation: 'compact',
        }).format(Number(value))
      );
    case 'NUMBER':
      //todo: currently BE return non-number values, this check can be removed once BE fixes the metadata type.(https://elsevier.atlassian.net/browse/FC-2414)
      return typeof value === 'number' ? new Intl.NumberFormat('en-US').format(value) : value;
    case 'TIMESTAMP':
      const date = new Date(value);
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      });
    default:
      return value;
  }
}

export const formatValue = (value: string | number): string =>
  typeof value === 'number' ? new Intl.NumberFormat('en-US').format(value) : value;
